import { Box, Button, TextField, InputAdornment, SvgIcon, Grid } from '@mui/material';
import { SearchIcon } from '../../Icons';
import CUModal from '../modals/CUModal';
import { useState } from 'react';

// Generic "Ajouter" button + search field + create/update modal shell shared by
// every AdminComponents *ListToolbar. Entity-specific extra filters/controls can
// be passed as children (rendered as extra Grid items next to the search field).
const EntityListToolbar = ({
    updateSearch,
    loadData,
    searchPlaceholder,
    CreateComponent,
    createComponentProps,
    hideAddButton,
    children,
    ...props
}) => {

    const [openCUModal, setOpenCUModal] = useState(false);
    const handleClose = () => {
        setOpenCUModal(false);
        loadData();
    }

    return (
        <>
            <CUModal
                open={openCUModal}
                handleClose={handleClose}
                component={CreateComponent}
                {...createComponentProps}
            />
            <Box {...props}>
                {!hideAddButton && (
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button color="primary" variant="contained" onClick={() => setOpenCUModal(true)}>Ajouter</Button>
                    </Box>
                )}
                <Box pb={4}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                size="small"
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SvgIcon fontSize="small" color="action"><SearchIcon /></SvgIcon>
                                        </InputAdornment>
                                    )
                                }}
                                placeholder={searchPlaceholder}
                                variant="outlined"
                                onChange={updateSearch}
                            />
                        </Grid>
                        {children}
                    </Grid>
                </Box>
            </Box>
        </>
    )
};

EntityListToolbar.defaultProps = {
    createComponentProps: {},
    hideAddButton: false,
};

export default EntityListToolbar;
